import { AuthTo } from '@common/Auth'
import { isUltimate } from '@merchant-backend/util'
import { Component } from 'react'

@AuthTo({
  isAuthed: isUltimate,
  link: '/localMerchant/potentialCustomersIntro'
})
export default class extends Component {
  render() {
    return this.props.children
  }
}
